import clsx from 'clsx';
import React from 'react';

type TSkeletonProps = {
  width?: string;
  height?: string;
  borderRadius?: string;
  className?: string;
  testId?: string;
}

const Skeleton: React.FC<TSkeletonProps> = ({
  width = 'w-full',
  height = 'h-[20px]',
  borderRadius = 'rounded-[6px]',
  className,
  testId,
}) => (
  <div
    className={clsx(
      'animate-shimmer bg-shimmer',
      width,
      height,
      borderRadius,
      className,
    )}
    data-testid={testId}
  />
);

export default Skeleton;
